import React from "react";

export default function ResidentialIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"
        stroke="#14508c"
        strokeWidth="1.5"
        fill="none"
      ></path>
      <rect
        x="9"
        y="13"
        width="6"
        height="8"
        rx="1"
        stroke="#14508c"
        strokeWidth="1.5"
        fill="none"
      ></rect>
    </svg>
  );
}
